import React from 'react';
import { Building2, Clock } from 'lucide-react';
import { useLanguage } from '../../i18n/LanguageContext';
export function SocialProofSection() {
  const {
    t
  } = useLanguage();
  return <section className="py-20 bg-[#EDE7F6]" data-id="element-199">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-200">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 text-center" data-id="element-201">
          <div className="flex flex-col items-center" data-id="element-202">
            <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center text-[#7C4DFF] mb-6 shadow-sm" data-id="element-203">
              <Building2 size={32} data-id="element-204" />
            </div>
            <div className="text-6xl font-bold text-[#7C4DFF] mb-2" data-id="element-205">20+</div>
            <p className="text-xl text-gray-600 font-medium" data-id="element-206">
              {t('social.gardens')}
            </p>
          </div>

          <div className="flex flex-col items-center" data-id="element-207">
            <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center text-[#7C4DFF] mb-6 shadow-sm" data-id="element-208">
              <Clock size={32} data-id="element-209" />
            </div>
            <div className="text-6xl font-bold text-[#7C4DFF] mb-2" data-id="element-210">28.8</div>
            <p className="text-xl text-gray-600 font-medium" data-id="element-211">
              {t('social.hours')}
            </p>
          </div>
        </div>
      </div>
    </section>;
}